import { API } from "./api";

const CF = "https://speed.cloudflare.com";
const rnd = () => Math.random();
const trim = (u) => (u || "").replace(/\/+$/, "");

const libre = (base) => ({
  ping: () => `${trim(base)}/empty.php?cors=true&r=${rnd()}`,
  down: () => `${trim(base)}/garbage.php?cors=true&ckSize=25&r=${rnd()}`,
  up: () => `${trim(base)}/empty.php?cors=true&r=${rnd()}`,
});

export const SERVERS = [
  { id: "cloudflare", name: "Nearest SA: Cloudflare JHB / CPT / DBN (NAPAfrica)", target: {
    ping: () => `${CF}/__down?bytes=0&r=${rnd()}`, down: () => `${CF}/__down?bytes=25000000&r=${rnd()}`, up: () => `${CF}/__up` } },
  { id: "lon", name: "London, UK (Clouvider, LibreSpeed)", target: libre("https://lon.speedtest.clouvider.net/backend") },
  { id: "ams", name: "Amsterdam, NL (Clouvider, LibreSpeed)", target: libre("https://ams.speedtest.clouvider.net/backend") },
  { id: "ams-st", name: "Amsterdam, NL (Sharktech, LibreSpeed)", target: libre("https://amsspeed.sharktech.net/backend") },
  { id: "fra", name: "Frankfurt, DE (Clouvider, LibreSpeed)", target: libre("https://fra.speedtest.clouvider.net/backend") },
  { id: "app", name: "CellCheckPoint app server (USA)", target: {
    ping: () => `${API}/speed/ping?r=${rnd()}`, down: () => `${API}/speed/download?size_mb=10&r=${rnd()}`, up: () => `${API}/speed/upload` } },
  { id: "custom", name: "Custom server (e.g. NAPAfrica / Teraco hosted)", target: null },
];

const COLO_CITY = { JNB: "Johannesburg", CPT: "Cape Town", DUR: "Durban", GBE: "Gaborone", MPM: "Maputo", WDH: "Windhoek", HRE: "Harare", NBO: "Nairobi", LOS: "Lagos", LHR: "London", AMS: "Amsterdam", FRA: "Frankfurt", ORD: "Chicago" };

const CITY = { lon: "London", ams: "Amsterdam", "ams-st": "Amsterdam", fra: "Frankfurt" };
const PROVIDER = { cloudflare: "Cloudflare", lon: "Clouvider", ams: "Clouvider", fra: "Clouvider", "ams-st": "Sharktech", app: "CellCheckPoint" };

export const testProviderLabel = (t) => {
  if (!t.test_server) return "CellCheckPoint (USA)";
  const prov = t.test_server === "custom" ? "Custom" : PROVIDER[t.test_server] || t.test_server;
  const where = t.test_server === "cloudflare" ? [t.server_city, t.server_colo && `(${t.server_colo})`].filter(Boolean).join(" ") : t.test_server === "app" ? "USA" : CITY[t.test_server] || t.server_city;
  return where ? `${prov} · ${where}` : prov;
};

export const resolveServers = (cfg) =>
  (cfg.server_priority?.length ? cfg.server_priority : ["cloudflare", "app"])
    .map((id) => {
      if (id === "custom") return cfg.custom_server_url ? { id, name: cfg.custom_server_name || cfg.custom_server_url, target: libre(cfg.custom_server_url) } : null;
      return SERVERS.find((s) => s.id === id) || null;
    })
    .filter(Boolean);

export const customTarget = libre;

export async function probe(target, timeout = 4000) {
  const ctl = new AbortController();
  const timer = setTimeout(() => ctl.abort(), timeout);
  const t0 = performance.now();
  try {
    const res = await fetch(target.ping(), { cache: "no-store", signal: ctl.signal });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return Math.round(performance.now() - t0);
  } finally { clearTimeout(timer); }
}

export async function serverMeta(server) {
  if (server.id !== "cloudflare") return { test_server: server.id, server_colo: null, server_city: server.name };
  try {
    const txt = await (await fetch(`${CF}/cdn-cgi/trace`, { cache: "no-store" })).text();
    const colo = /colo=([A-Z]+)/.exec(txt)?.[1] || null;
    return { test_server: "cloudflare", server_colo: colo, server_city: colo ? COLO_CITY[colo] || colo : null };
  } catch {
    return { test_server: "cloudflare", server_colo: null, server_city: null };
  }
}
